import { SmileOutlined } from "@ant-design/icons-vue";
import { Modal } from "ant-design-vue";
import { createVNode } from "vue";
import md5 from "js-md5";

export function COU_GetHeader(referer, origin, header2) {
  if (!referer) referer = window.location.href;
  if (!origin) origin = window.location.origin;
  var header = { "zzb-header-referer": referer, "zzb-header-Origin": origin };
  if (header2) {
    header2["zzb-header-referer"] = referer;
    header2["zzb-header-Origin"] = origin;
    return header2;
  }
  return header;
}

export function COU_Sleep(time) {
  return new Promise((resolve) => setTimeout(resolve, time));
}

export function COU_Alert(content) {
  if (!content) content = ``;
  if (COU_IsDevOrTest()) alert(content);
}

export function COU_getUrlParam(name) {
  //构造一个含有目标参数的正则表达式对象
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  //匹配目标参数
  var r = window.location.search.substr(1).match(reg);
  //返回参数值
  if (r != null) {
    return decodeURI(r[2]);
  }
  return null;
}

export function COU_fillNumberToTwoWord(num) {
  if (num < 10 && num >= 0) return "0" + num;
  return num + "";
}
export function COU_IsTest() {
  return process.env.NODE_ENV != "production";
}

export function COU_IsDev() {
  return window.location.href.indexOf("test") > 0;
}

export function COU_IsDevOrTest() {
  return COU_IsTest() || COU_IsDev();
}

export function COU_regPhone(v) {
  return COU_regOne(v, /^1(\d{10})$/);
}
export function COU_regOne(t, re) {
  if (!t) return false;
  var arr = re.exec(t);
  if (arr && arr.length > 1) {
    return arr[1];
  }
  return false;
}
export function COU_regOneStr(t, re) {
  var a = COU_regOne(t, re);
  if (!a) a = "";
  return a;
}

export function COU_regGetUrlOneStr(content) {
  var reg = /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-)+)/g;
  content = content.match(reg);
  return content?.[0] || null;
}

export function COU_arrRegOneStr(t, regArray) {
  var strRes = "";
  for (let i = 0; i < regArray.length; i++) {
    strRes = COU_regOneStr(t, regArray[i]);
    if (strRes) break;
  }
  return strRes;
}

export function COU_regFloat(t, defaultValue) {
  if (!t) return defaultValue;
  t += "";
  t = t.replace(",", "");
  var re = new RegExp(/\d+\.?\d*/);
  var arr = re.exec(t);

  if (arr && arr.length > 0) {
    var n = parseFloat(arr[0]);
    if ((t + "").indexOf("万") > 0) n = n * 10000;
    if ((t + "").indexOf("萬") > 0) n = n * 10000;
    return n;
  }
  return defaultValue;
}

export function COU_regInt(t, defaultValue) {
  if (!t) return defaultValue;
  t += "";
  t = t.replace(",", "");
  var re = new RegExp(/\d+/);
  var arr = re.exec(t);
  if (arr && arr.length > 0) {
    var n = parseInt(arr[0]);
    if ((t + "").indexOf("万") > 0 || (t + "").indexOf("萬") > 0) {
      n = parseInt(COU_regFloat(t, defaultValue));
    }
    return n;
  }
  return defaultValue;
}

export function SetAgreeXueYiOK() {
  var agreeKey = "zzb_yinsi_ag5ree_key";
  localStorage.setItem(agreeKey, "1");
}

// 精确运算 加
function addition(a, b) {
  let c, d, e;
  try {
    c = a.toString().split(".")[1].length;
  } catch (error) {
    c = 0;
  }
  try {
    d = b.toString().split(".")[1].length;
  } catch (error) {
    d = 0;
  }
  e = Math.pow(10, Math.max(c, d));
  return (multiplication(a, e) + multiplication(b, e)) / e;
}

// 精确运算 减
function subtraction(a, b) {
  var c, d, e;
  try {
    c = a.toString().split(".")[1].length;
  } catch (f) {
    c = 0;
  }
  try {
    d = b.toString().split(".")[1].length;
  } catch (f) {
    d = 0;
  }
  e = Math.pow(10, Math.max(c, d));
  return (multiplication(a, e) - multiplication(b, e)) / e;
}

// 精确运算 乘
function multiplication(a, b) {
  var c = 0,
    d = a.toString(),
    e = b.toString();
  try {
    c += d.split(".")[1].length;
  } catch (f) {
    c += 0;
  }
  try {
    c += e.split(".")[1].length;
  } catch (f) {
    c += 0;
  }
  return (
    (Number(d.replace(".", "")) * Number(e.replace(".", ""))) / Math.pow(10, c)
  );
}

// 精确运算 除
function division(a, b) {
  var c,
    d,
    e = 0,
    f = 0;
  try {
    e = a.toString().split(".")[1].length;
  } catch (g) {
    e = 0;
  }
  try {
    f = b.toString().split(".")[1].length;
  } catch (g) {
    f = 0;
  }
  c = Number(a.toString().replace(".", ""));
  d = Number(b.toString().replace(".", ""));
  return multiplication(c / d, Math.pow(10, f - e));
}
/***
 * COU_Arithmetic:运算符
 * a:数值1
 * b:数值2
 * type:运算符 + - /  * 默认是+
 */
export function COU_Arithmetic(a = 0, b = 1, type) {
  let result = 0;
  switch (type) {
    case "+":
      result = addition(a, b);
      break;
    case "-":
      result = subtraction(a, b);
      break;
    case "*":
      result = multiplication(a, b);
      break;
    case "/":
      result = division(a, b);
      break;
    default:
      result = addition(a, b);
      break;
  }
  return result;
}

//保留几位小数
export function COU_NumToFix(num, len) {
  num = parseFloat(num || 0);
  return parseFloat(num.toFixed(len));
}
//数据 向上取整还是进一还是不变
/**
 * num  :数字
 * type :类型
 * ceil  向上取整
 * floor 向下取整
 */
export function COU_ToPrecision(num, type) {
  num = parseFloat(num || 0);
  if (type === "ceil") return Math.ceil(num);
  else if (type === "floor") return Math.floor(num);
  return num;
}

// 判断淘宝是否有滑块
export function COU_CheckTbValidation(content) {
  if (
    content.includes(
      "/trade/detail/trade_order_detail.htm/_____tmd_____/punish"
    )
  )
    return true;
  if (
    content.includes(
      "/trade/detail/trade_order_detail.htm/_____tmd_____/verify"
    )
  )
    return true;
  if (content.includes("拖动滑块完成验证") || content.includes("滑块完成验证"))
    return true;
  if (content.includes("下方圆圈进行验证") || content.includes("圆圈进行验证"))
    return true;
  return false;
}

// 验证滑块(或者二次认证)
export function COU_CheckValidation(
  searchUrl,
  { content1, okText1, content2, okText2, okFn, cancelFn }
) {
  return new Promise((resolve) => {
    Modal.confirm({
      title: "温馨提示",
      icon: createVNode(SmileOutlined),
      content: content1,
      okText: okText1 || "确定",
      onOk() {
        searchUrl && window.open(searchUrl);
        Modal.confirm({
          title: "温馨提示",
          icon: createVNode(SmileOutlined),
          content: content2 || "点击确定后继续操作",
          okText: okText2 || "确定",
          onOk: () => {
            okFn?.();
            resolve();
          },
          onCancel() {
            cancelFn?.();
          },
        });
      },
      onCancel() {
        if (cancelFn) {
          cancelFn();
          resolve();
        }
      },
    });
  });
}

// 将字符串复制到剪切板
export const COU_CopyToClipboard = (str) => {
  const el = document.createElement("textarea");
  el.value = str;
  el.style.position = "absolute";
  el.style.left = "-9999px";
  document.body.appendChild(el);
  el.select();
  document.execCommand("copy");
  document.body.removeChild(el);
};

// base64文件转成file文件
export function COU_base64ToFile(base64, filename) {
  try {
    const arr = base64.split(",");
    console.log("base64 - 1.....", arr);
    const mime = arr[0].match(/:(.*?);/)[1];
    console.log("base64 - 2.....", mime);
    const suffix = mime.split("/")[1];
    console.log("base64 - 3.....", suffix);
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], `${filename || +new Date()}.${suffix}`, {
      type: mime,
    });
  } catch (error) {
    console.log("base64ToFile ....", error);
  }
}

// 图片链接转成base64
export function COU_GetUrlToBase64Image(url, width, height) {
  return new Promise((resolve) => {
    const image = new Image();
    image.src = url;
    image.setAttribute("crossOrigin", "anonymous");
    image.onload = () => {
      try {
        const finalWidth = width || image.width;
        const finalHeight = height || image.height;
        const canvas = document.createElement("canvas");
        canvas.width = finalWidth;
        canvas.height = finalHeight;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(image, 0, 0, finalWidth, finalHeight);
        const base64 = canvas.toDataURL("image/jpeg");
        resolve(base64);
      } catch (error) {
        console.log("toBase64Image........", error);
        resolve("");
      }
    };
    image.onerror = (error) => {
      console.log("转成base64失败。。。", error);
      resolve("");
    };
  });
}

// 压缩图片，最后得到base64
export function COU_canvasDataURL(path, obj) {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = path;
    img.setAttribute("crossOrigin", "Anonymous");
    img.onload = function () {
      const num = 750;
      let w, h;
      if (w > h) {
        w = num;
        h = (this.height / this.width) * num;
      } else {
        h = num;
        w = (this.width / this.height) * num;
      }
      let quality = 0.7; // 默认图片质量为0.7 quality值越小，所绘制出的图像越模糊
      //生成canvas
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      const anw = document.createAttribute("width");
      anw.nodeValue = w;
      const anh = document.createAttribute("height");
      anh.nodeValue = h;
      canvas.setAttributeNode(anw);
      canvas.setAttributeNode(anh);
      ctx.drawImage(this, 0, 0, w, h);
      if (obj.quality && obj.quality <= 1 && obj.quality > 0)
        quality = obj.quality;
      resolve(canvas.toDataURL("image/jpeg", quality));
    };
  });
}

// 将英文字符串首字母变成小写
export function COU_fristStrToLowerCase(a) {
  return a.replace(a[0], a[0].toLowerCase());
}

// 将英文字符串首字母变成大写
export function COU_fristStrToUpperCase(a) {
  return a.replace(a[0], a[0].toUpperCase());
}

export const DownloadIamge = (url, name) => {
  const image = new Image();
  image.src = url;
  image.setAttribute("crossOrigin", "anonymous");
  image.onload = function () {
    const canvas = document.createElement("canvas");
    canvas.width = image.width;
    canvas.height = image.height;
    const context = canvas.getContext("2d");
    context.drawImage(image, 0, 0, image.width, image.height);
    const url = canvas.toDataURL("image/jpg");
    // 生成一个a元素
    const a = document.createElement("a");
    // 创建一个单击事件
    const event = new MouseEvent("click");
    // 将a的download属性设置为我们想要下载的图片名称，若name不存在则使用‘下载图片名称’作为默认名称
    a.download = name || "图片";
    // 将生成的URL设置为a.href属性
    a.href = url;
    // 触发a的单击事件
    a.dispatchEvent(event);
  };
};

export function COU_formatDateToStr2(d, format) {
  var date = {
    "M+": d.getMonth() + 1,
    "d+": d.getDate(),
    "h+": d.getHours(),
    "m+": d.getMinutes(),
    "s+": d.getSeconds(),
    "q+": Math.floor((d.getMonth() + 3) / 3),
    "S+": d.getMilliseconds(),
  };
  if (/(y+)/i.test(format)) {
    format = format.replace(
      RegExp.$1,
      (d.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  for (var k in date) {
    if (new RegExp("(" + k + ")").test(format)) {
      format = format.replace(
        RegExp.$1,
        RegExp.$1.length == 1
          ? date[k]
          : ("00" + date[k]).substr(("" + date[k]).length)
      );
    }
  }
  return format;
}

export function COU_formatDateToStr(t) {
  var myDate = new Date();
  if (t) myDate = new Date(t);
  var da = COU_formatDateToStr2(myDate, "yyyy-MM-dd hh:mm:ss");
  return da;
}

export function COU_getFormatTime(timestamp) {
  //获取当前日期时间
  var year = timestamp.getFullYear(); //年
  var month = timestamp.getMonth() + 1; //月
  var day = timestamp.getDate(); //日
  var clock = year + "-";
  if (month < 10) clock += "0";
  clock += month + "-";
  if (day < 10) clock += "0";
  clock += day;
  return clock;
}

// 验证滑块
export function CheckValidation(searchUrl, contentInfo, okMsg, okBtn1, params) {
  return new Promise((resolve) => {
    Modal.confirm({
      class: params?.class,
      title: "温馨提示",
      icon: createVNode(SmileOutlined),
      content: contentInfo,
      okText: okBtn1 || "确定",
      cancelText: params?.cancelText || "取消",
      onOk() {
        window.open(searchUrl, "_blank");
        Modal.confirm({
          class: params?.class,
          title: "温馨提示",
          icon: createVNode(SmileOutlined),
          content: okMsg || "点击确定后继续加载",
          okText: params?.btn || "确定",
          onOk: () => {
            params?.okFn?.();
            resolve();
          },
          onCancel() {
            if (params?.cancelFn) {
              params.cancelFn?.();
              resolve("cancel");
            }
          },
        });
      },
      onCancel() {
        debugger;
        if (params?.cancelFn) {
          params.cancelFn?.();
          resolve("cancel");
        }
      },
    });
  });
}

//本地采购订单备注设置的key
export function COU_PurchasedOrderRemark(relationId = "") {
  return `yjxd_order_purchasedOrderRemarkType_${relationId}`;
}

//将搜图的过滤条件保存到本地的key
export function COU_Tb1688SearchImgFilterKey() {
  return `yjxd_order_tb1688SearchImgFilterKey`;
}

export function COU_GetSignHeaders(path) {
  const obj = {};
  const time = new Date().getTime();
  obj["zzb-time"] = time;
  obj["zzb-sign"] = getKey(`${time}_${path}`);
  return obj;
}

function getKey(value) {
  let sign;
  try {
    sign = md5(
      `zzb2021zzbAppSecretKey_zzb2021_${value}_zzb2021zzbAppSecretKey`
    );
  } catch (e) {
    console.log(e);
  }
  return sign;
}

export function COU_Trim(content) {
  if (!content) content = "";
  content = content.replace(/^\s+/, "");
  content = content.replace(/\s+$/, "");
  return content;
}

export function COU_changeTimeFormat(time) {
  var d = new Date(time);
  function addZero(s) {
    return s < 10 ? "0" + s : s;
  }
  var ymd =
    d.getFullYear() +
    "-" +
    addZero(d.getMonth() + 1) +
    "-" +
    addZero(d.getDate());
  var hms =
    addZero(d.getHours()) +
    ":" +
    addZero(d.getMinutes()) +
    ":" +
    addZero(d.getSeconds());
  var ymdHms = ymd + " " + hms;
  return ymdHms;
}

export const encrypt_local_1688_key = "xiaofeng_tb1688_use_encrypt_switch_zfb";
